import { RootState } from "store";
import store from "store";

export const adminRoleCheck = (
  allowedAdminRoles: string[] = []
): boolean => {
  const state = store?.getState() as RootState | undefined;
  const userRoles: string[] = state?.auth?.roles ?? [];

  const allAdminRoles = [
    "organization_admin",
    "program_admin",
    "super_admin",
    "community_admin",
    "admin",
  ];

  const userAdminRoles = userRoles.filter((role) =>
    allAdminRoles.includes(role)
  );

  return (
    userAdminRoles.length > 0 &&
    userAdminRoles.every((role) => allowedAdminRoles.includes(role))
  );
};

export default adminRoleCheck;
